import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import SaveIMPCSelectionFormContainer from '../containers/SaveIMPCSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class SaveIMPCSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    this.props.saveSelection({
      name,
      checkedMailProcessingCenters: this.props.checkedMailProcessingCenters,
    });
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.save.impc.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <SaveIMPCSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          checkedMailProcessingCenters={this.props.checkedMailProcessingCenters}
        />
      </Modal>
    );
  }
}

SaveIMPCSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default (SaveIMPCSelectionModal);
